import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => {
  // Drawer styling
  const drawerWidthClose = '60px';

  // custom styling
  const iconSize = theme.spacing(3);
  const listItemHoverColor = 'rgba(255, 255, 255, 0.1)';
  const listItemSelectedColor = theme.evPalette.ocean['500'];
  const iconDefaultColor = theme.evPalette.charcoal['500'];
  const navbarDefaultColor = theme.evPalette.charcoal['900'];
  const appIconSelectedColor = theme.evPalette.salt['100'];
  const animationDuration = '400ms';
  return {
    navbarHeightWithHeader: {
      height: `calc(100vh - ${theme.typography.pxToRem(44)})`,
    },
    navbarHeightWithoutHeader: {
      height: '100vh',
    },
    drawer: {
      visibility: (props) => (props.show ? 'visible' : 'hidden'),
      opacity: (props) => (props.show ? 1 : 0),
      transition: `all .2s ${theme.transitions.easing.easeInOut}`,
      overflowY: 'hidden',
      flexShrink: 0,
      whiteSpace: 'nowrap',
      backgroundColor: navbarDefaultColor,
      zIndex: 10000,
    },
    drawerClose: {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: 'hidden',
      width: (props) => (props.show ? drawerWidthClose : 0),
      zIndex: 100,
    },
    removeListPadding: {
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
    },
    listStyles: {
      flexDirection: 'column',
      marginBottom: theme.spacing(1.5),
      paddingTop: theme.spacing(0.75),
      paddingBottom: theme.spacing(0.5),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      '&:hover': {
        backgroundColor: listItemHoverColor,
        cursor: 'pointer',
      },
      borderRadius: theme.spacing(0.25),
    },
    selectedAppStyle: {
      backgroundColor: listItemSelectedColor,
      '&:hover': {
        backgroundColor: listItemSelectedColor,
      },
    },
    listItemIcon: {
      minWidth: iconSize,
    },
    listItemText: {
      fontSize: theme.typography.pxToRem(11),
      lineHeight: theme.typography.pxToRem(14),
      textAlign: 'center',
      whiteSpace: 'normal',
      marginTop: theme.spacing(0.25),
      color: theme.palette.common.white,
      overflow: 'hidden',
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
      'word-break': 'break-word',
    },
    appIcon: {
      width: iconSize,
      height: iconSize,
      fill: iconDefaultColor,
      stroke: iconDefaultColor,
    },
    appIconSelected: {
      fill: appIconSelectedColor,
      stroke: appIconSelectedColor,
    },
    listContent: {
      paddingTop: theme.spacing(1.25),
      paddingLeft: theme.typography.pxToRem(3),
      paddingRight: theme.typography.pxToRem(2),
      maxHeight: 'calc(100% - 32px)',
      overflowX: 'hidden',
    },
    showSrollBar: {
      overflowY: 'overlay',
      scrollbarWidth: 'none',
      'background-color': 'rgba(255, 255, 255, 0.5)',
      '-webkit-background-clip': 'text',
      '&::-webkit-scrollbar': {
        width: theme.spacing(1),
      },
      '&::-webkit-scrollbar-thumb': {
        borderRight: '2px solid rgba(0, 0, 0, 0)',
        backgroundClip: 'padding-box',
        borderRadius: theme.spacing(1.25),
        backgroundColor: 'inherit',
      },
      '&:hover': {
        /* show scrollbar on hover */
        scrollbarWidth: 'thin',
        scrollbarColor: 'rgba(255, 255, 255, 0.5) rgba(255, 255, 255, 0)',
      },
    },
    hideScrollBar: {
      transition: `background-color ${animationDuration}`,
      backgroundColor: 'rgba(0, 0, 0, 0)',
    },
    scrolToTopButton: {
      position: 'absolute',
      left: theme.spacing(0.5),
      bottom: theme.spacing(2),
      zIndex: 1,
    },
    dummyApp: {
      height: theme.spacing(4),
    },
    scrollToTop: {
      transition: `transform ${animationDuration} ease-in-out`,
      transform: 'rotateX(0deg) rotateY(180deg)',
    },
    scrollToBottom: {
      transition: `transform ${animationDuration} ease-in-out`,
      transform: 'rotateX(180deg) rotateY(360deg)',
    },
  };
});
